import React from 'react'
import Navbar from '../../Components/Navbar'

function Camera() {
    return (
        <div>
            <Navbar/>
            <h1>Camera.</h1>
        </div>
    )
}

export default Camera
